export const AGREEMENT_MODAL_TITLE = "Client Participation Agreement & Bill of Rights";

export const AGREEMENT_VERSION = "1.0";

export const SIGN_BUTTON_TEXT = "Sign Agreement";
export const CANCEL_BUTTON_TEXT = "Cancel";
export const SIGNING_TEXT = "Signing...";

export const SIGNATURE_LABEL = "Type your full legal name to sign";
export const SIGNATURE_PLACEHOLDER = "e.g., Jane Marie Smith";
export const CHECKBOX_LABEL =
  "I have read, understand, and agree to the terms of the Client Participation Agreement and Client Bill of Rights.";

export const SUCCESS_MESSAGE = "Agreement signed successfully!";
export const ERROR_MESSAGE = "Failed to sign agreement. Please try again.";

// Parent / Legal Guardian fields (for minor clients ages 14-17)
export const GUARDIAN_SECTION_TITLE = "Parent / Legal Guardian Acknowledgment";
export const GUARDIAN_SECTION_NOTICE =
  "Because the client is between 14-17 years of age, a parent or legal guardian must also acknowledge and sign this agreement before proceeding.";
export const GUARDIAN_NAME_LABEL = "Parent / Legal Guardian Full Name";
export const GUARDIAN_NAME_PLACEHOLDER = "e.g., John David Smith";
export const GUARDIAN_SIGNATURE_LABEL =
  "Parent / Legal Guardian Signature (type full legal name)";
export const GUARDIAN_SIGNATURE_PLACEHOLDER = "Type full legal name to sign";
export const GUARDIAN_RELATIONSHIP_LABEL = "Relationship to Minor";
export const GUARDIAN_EMAIL_LABEL = "Parent / Legal Guardian Email";
export const GUARDIAN_EMAIL_PLACEHOLDER = "e.g., parent@email.com";
export const GUARDIAN_RELATIONSHIP_OPTIONS = [
  "Parent",
  "Legal Guardian",
  "Other",
];

export const AGREEMENT_CONTENT = {
  title: "Nirva Client Participation Agreement & Client Bill of Rights",
  effectiveDate: "March 2026",
  sections: [
    {
      heading: "Welcome to Nirva",
      content:
        "Thank you for choosing Nirva as your platform for interpersonal hypnotherapy services. This Client Participation Agreement outlines the terms and expectations for your participation in sessions booked through our platform. By signing this agreement, you acknowledge that you have read, understood, and agree to abide by the guidelines set forth below.",
    },
    {
      heading: "1. Nature of Services",
      content:
        "Nirva connects clients with certified interpersonal hypnotherapy practitioners for virtual consultation and session services. Hypnotherapy is a complementary wellness modality and is not a substitute for medical, psychological, or psychiatric treatment. Practitioners on the Nirva platform are independent contractors and not employees of Nirva.",
    },
    {
      heading: "2. Client Responsibilities",
      items: [
        "Provide accurate and truthful information during intake and throughout the therapeutic relationship.",
        "Attend scheduled sessions on time. If you need to cancel or reschedule, please do so at least 24 hours in advance.",
        "Communicate openly with your practitioner about your comfort level, goals, and any concerns.",
        "Understand that results vary and depend on individual participation and engagement.",
      ],
    },
    {
      heading: "3. Confidentiality",
      content:
        "All information shared during sessions is treated as confidential. Practitioners are bound by professional ethics to protect your privacy. However, confidentiality may be limited in cases where there is a risk of harm to yourself or others, or where disclosure is required by law.",
    },
    {
      heading: "4. Payment & Cancellation Policy",
      items: [
        "Your first 30-minute consultation is complimentary.",
        "Follow-up sessions are charged based on the practitioner's hourly rate and session duration.",
        "A valid payment method must be on file before booking paid sessions.",
        "Cancellations made less than 24 hours before a session may be subject to a cancellation fee.",
        "No-shows may be charged the full session rate.",
      ],
    },
    {
      heading: "5. Virtual Session Guidelines",
      items: [
        "Sessions are conducted via secure video conferencing.",
        "Ensure you are in a quiet, private, and comfortable environment for your session.",
        "A stable internet connection is required for optimal session quality.",
        "Recording of sessions by clients is not permitted without prior written consent from the practitioner.",
      ],
    },
    {
      heading: "6. Right to Discontinue",
      content:
        "You have the right to discontinue services at any time without penalty. If you wish to end your therapeutic relationship with a practitioner, you may do so by notifying Nirva or your practitioner directly.",
    },
    {
      heading: "Client Bill of Rights",
      subtitle: "As a Nirva client, you have the right to:",
      items: [
        "Be treated with dignity, respect, and compassion at all times.",
        "Receive services from qualified, certified practitioners who adhere to professional ethical standards.",
        "Be fully informed about the nature of hypnotherapy services, including potential benefits and limitations.",
        "Ask questions about your practitioner's qualifications, approach, and methods.",
        "Expect confidentiality of all personal information and session content, subject to legal exceptions.",
        "Provide informed consent before any session or procedure begins.",
        "Refuse or discontinue any technique or service at any time during a session.",
        "Access your own records and request information about your care.",
        "File a complaint or provide feedback about your experience without fear of retaliation.",
        "Be informed of fees and payment policies before services are rendered.",
      ],
    },
    {
      heading: "7. Acknowledgment",
      content:
        "By signing below, I confirm that I have read and understood this Client Participation Agreement and Client Bill of Rights. I voluntarily agree to participate in interpersonal hypnotherapy services through Nirva under the terms described above.",
    },
  ],
};
